module.exports = __webpack_public_path__ + "img/sp_top.39b94fba.png";